<template>
  <div class="content-wrapper">
    <div class="workpage-content-wrapper">
      <breadcrumbs v-if="breadcrumbs" :items="breadcrumbs" />
      <div class="workpage-left-column">
        <LeftMenu v-if="menuItems" :items="menuItems" />

        <LeftBanner />
      </div>

      <router-view :key="$route.fullPath"></router-view>
    </div>
  </div>
</template>

<script>
import ProdMixin from "@/mixins/ProdMixin.vue";
import CatLeftMenuMixin from "@/components/pages/categories/CatLeftMenuMixin.vue";
export default {
  mixins: [ProdMixin, CatLeftMenuMixin],
  created() {
    this.prodMixinInit();
  },
  computed: {
    breadcrumbs() {
      let out = [
        {
          label: "Главная",
          to: { name: "main" },
        },
      ];

      if (this.$route.params.groupId) {
        out.push({
          label: "Каталог",
          to: { name: "categories" },
        });
        out.push({
          label: this.category.name,
        });
      } else {
        out.push({
          label: "Каталог",
        });
      }
      return out;
    },
  },
};
</script>
